import script from "./EstimateFrequentWorkModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EstimateFrequentWorkModal.vue?vue&type=script&setup=true&lang=js"

import "./EstimateFrequentWorkModal.vue?vue&type=style&index=0&id=24203e24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24203e24"]])

export default __exports__